<section class="newsletter-section" #newsletterSection>
  <div class="container">
    <div class="newsletter-content">
      <div class="newsletter-text">
        <h2>Stay Updated</h2>
        <p>Get notified about new classes, events, and exclusive offers</p>
      </div>
      <div class="newsletter-form">
        <form (ngSubmit)="onSubmit()" #newsletterForm="ngForm">
          <div class="input-group">
            <input
              type="email"
              [(ngModel)]="email"
              name="email"
              placeholder="Enter your email address"
              required
              class="email-input">
            <button
              type="submit"
              [disabled]="loading || !email"
              class="subscribe-btn">
              <span *ngIf="!loading">Subscribe</span>
              <span *ngIf="loading">Subscribing...</span>
            </button>
          </div>
          <div *ngIf="error" class="error-message">{{ error }}</div>
          <div *ngIf="success" class="success-message">Thank you for subscribing!</div>
        </form>
      </div>
    </div>
  </div>
</section>
